import { MapPinOff, RefreshCw } from "lucide-react";

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

const HELP = {
  denied: () =>
    isIOS()
      ? "Réglages iPhone → Confidentialité → Service de localisation → Safari (ou WÔMA) → « Lorsque l'app est active »."
      : "Android : appuyez sur le cadenas à côté de l'adresse → Autorisations → Position → Autoriser.",
  unsupported: () => "Votre appareil ne permet pas la géolocalisation. Utilisez un navigateur récent.",
  error: () => "Signal GPS introuvable. Activez la localisation du téléphone puis réessayez.",
};

export const GeoPermissionNotice = ({ status, onRetry }) => {
  if (!HELP[status]) return null;
  return (
    <div className="absolute inset-x-3 bottom-3 z-[500] bg-[#0F172A]/95 backdrop-blur-md border border-orange-500/40 rounded-2xl p-3 flex items-start gap-3" data-testid="geo-permission-notice">
      <MapPinOff className="text-orange-400 flex-shrink-0 mt-0.5" size={18} />
      <div className="flex-1 min-w-0">
        <p className="text-[11px] font-black uppercase tracking-widest text-orange-400">
          {status === "denied" ? "Localisation refusée" : "Position indisponible"}
        </p>
        <p className="text-[11px] text-slate-300 leading-relaxed mt-1">{HELP[status]()}</p>
      </div>
      {status !== "unsupported" && (
        <button type="button" onClick={onRetry} className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors flex-shrink-0" data-testid="geo-retry-btn" aria-label="Réessayer">
          <RefreshCw size={14} className="text-white" />
        </button>
      )}
    </div>
  );
};
